<a class="align-items-center d-flex" style="gap: 10px" [routerLink]="'/'">
  <img src="assets/svg/logo-ar-right.svg" [width]="logoRightW" alt="Awqaf" />
  <img src="assets/svg/logo-ar-left.svg" [width]="logoLeftW" alt="Awqaf" />
</a>
